import { Alert, Page, Text } from '@ui/themed';
import { t } from 'i18next';
import { INTERCOM_TRIGGER } from '../../../constants/intercom';
import { useHandlers, useUser, withPageProviders } from '../../../context/page-context';
import { PartnerActionCard } from '../components/partner-action-card';
import { PARTNER_PORTAL_I18N, PARTNER_PORTAL_URLS } from '../constants';

const PAGE = PARTNER_PORTAL_I18N.page;

export const PartnerOverviewPage = withPageProviders(PartnerOverviewPageContents);

function PartnerOverviewPageContents() {
  const { navigationHandler } = useHandlers();
  const { firstName } = useUser();

  function openPortal(url: string) {
    navigationHandler.navigate(url, { absolute: true, newTab: true });
  }

  return (
    <Page
      title={t(`${PAGE}.title`, { firstName: firstName || '' })}
      description={t(`${PAGE}.description`)}
      secondaryActions={[
        {
          label: t(`${PAGE}.refer_action`),
          icon: 'userAdd',
          onClick: () => openPortal(PARTNER_PORTAL_URLS.portal),
        },
      ]}
    >
      <Alert variant="info" headingLevel="h2" title={t(`${PAGE}.test_mode.title`)}>
        <Text>{t(`${PAGE}.test_mode.body`)}</Text>
      </Alert>

      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
        <PartnerActionCard
          icon="userAdd"
          title={t(`${PAGE}.cards.refer.title`)}
          body={t(`${PAGE}.cards.refer.body`)}
          action={t(`${PAGE}.cards.refer.action`)}
          onClick={() => openPortal(PARTNER_PORTAL_URLS.leads)}
        />
        <PartnerActionCard
          icon="document"
          title={t(`${PAGE}.cards.guides.title`)}
          body={t(`${PAGE}.cards.guides.body`)}
          action={t(`${PAGE}.cards.guides.action`)}
          onClick={() => openPortal(PARTNER_PORTAL_URLS.partnerRoom)}
        />
        <PartnerActionCard
          icon="chat"
          title={t(`${PAGE}.cards.slack.title`)}
          body={t(`${PAGE}.cards.slack.body`)}
          action={t(`${PAGE}.cards.slack.action`)}
          onClick={() => {}}
          className={INTERCOM_TRIGGER.partnerSlack}
        />
        <PartnerActionCard
          icon="chat"
          title={t(`${PAGE}.cards.support.title`)}
          body={t(`${PAGE}.cards.support.body`)}
          action={t(`${PAGE}.cards.support.action`)}
          onClick={() => {}}
          className={INTERCOM_TRIGGER.partnerSupport}
        />
      </div>
    </Page>
  );
}
